import type * as React from 'react';
import { formatCurrency, priceCentsToUnits, type Currency } from '@etiquetachef/types';

type Props = {
  amount: number;
  currency: Currency;
  locale: string;
};

/**
 * Display de valor monetário (admin, Cloudscape/sem Tailwind). `amount` em
 * CENTS — a conversão para unidades acontece aqui; o caller NÃO divide por 100.
 * Substitui o `MoneyDisplay` do ui-shared (que usava classes Tailwind).
 *
 * Origem: sem issue — commit 627b442cc, 2026-06-09 (componentes visuais
 * Cloudscape no `/tenants/:id`).
 *
 * Usado por: telas de cobrança e financeiro do admin — `PendingPage`,
 * `BillingOverviewPage`, `InvoiceDetailPage`, `InvoiceTable`, `PaymentTable`,
 * `BillingCard`, `TenantFinanceTab`, `TransactionsTable`, `RefundsTable`.
 */
export function MoneyDisplay({ amount, currency, locale }: Props): React.JSX.Element {
  return (
    <span style={{ fontVariantNumeric: 'tabular-nums' }}>
      {formatCurrency(priceCentsToUnits(amount), currency, locale)}
    </span>
  );
}
